import server from 'utils/request';

/**
 * 登陆接口
 * @param data
 */
export function login(data) {
  return server({
    url: '/portal/login',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 手机号登陆接口
 * @param data
 */
export function loginByPhone(data) {
  return server({
    url: '/portal/loginSms',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 登出接口
 * @param data
 */
export function logout() {
  return server({
    url: '/portal/logout',
    method: 'get'
  })
}

/**
 * 修改密码
 * @param data
 */
export function changePwd(data) {
  return server({
    url: '/user/updatePwd',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 重置密码
 * @param data
 */
export function resetPwd(data, sessionId) {
  return server({
    url: '/user/forgetPwd',
    method: 'post',
    headers: {'ncac_sessionId': sessionId},
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}



// WEBPACK FOOTER //
// ./src/api/login/login.js